import angular from 'angular';

const ERROR_MESSAGE_MAP = {
    SERVICE_INVOICE_ALREADY_USE: 'error.functional.service_invoice_already_use',
    SERVICE_ORDER_ALREADY_USE: 'error.functional.service_order_already_use',
    SERVICE_DOCUMENTATION_SPACE_ALREADY_USE: 'error.functional.service_documentation_space_already_use',
};

class principalBuyerCtrl {
    /* @ngInject */
    constructor(PRINCIPAL, PrincipalSvc, AuthSvc, $uibModal, logger, EMAIL_REGEXP) {
        this.PRINCIPAL = PRINCIPAL;
        this.PrincipalSvc = PrincipalSvc;
        this.AuthSvc = AuthSvc;
        this.$uibModal = $uibModal;
        this.logger = logger;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
    }

    $onInit() {
        if (this.create || !this.principal.buyer.paramBuyer) {
            this.principal.buyer.transmissionModeFtp = true;
        }
        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };
        this.resetPrincipal = angular.copy(this.principal);
        this.invitationTypes = this.PRINCIPAL.invitationType;
        this.reportFrequencies = this.PrincipalSvc.getReportFrequencies();
        this.invitationReportErrorFrequencies = this.PrincipalSvc.getInvitationReportErrorFrequencies();
        this.buyerReportRemindersFrequencyAllowed =
            this.principal.buyer.buyerReportRemindersFrequency !== this.PRINCIPAL.reportFrequencies[3];
        this.langs = this.PrincipalSvc.getLangs();
        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };
        this.emailTemplateType = this.PRINCIPAL.emailTemplateType;
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    importTemplateEmail() {
        this.$uibModal
            .open({
                component: 'modalEmailInvitation',
                resolve: {
                    principal: () => {
                        return this.principal;
                    },
                    type: () => {
                        return 'buyer';
                    },
                },
            })
            .result.then(
                () => {},
                () => {}
            );
    }

    previewTemplateEmail(typeTemplate) {
        this.$uibModal
            .open({
                component: 'modalPreviewEmail',
                resolve: {
                    principal: () => {
                        return this.principal;
                    },
                    typeTemplate: () => {
                        return typeTemplate;
                    },
                    langCode: () => {
                        return this.langCode;
                    },
                },
                windowClass: 'app-modal-window',
            })
            .result.then(
                () => {},
                () => {}
            );
    }

    isEmail(value) {
        // Regexp utilisé dans Angular pour valider les input[type=email]
        return this.EMAIL_REGEXP.test(value.text);
    }

    cancel() {
        this.principal = angular.copy(this.resetPrincipal);
    }

    update() {
        if (this.isBillingFlowInvoicesNotValid()) {
            this.form.buyerInvoices.$setValidity('billingFlowInvoices', false);
        }

        if (this.isBillingFlowInvitationEmailNotValid()) {
            this.form.buyerBillingFlow.$setValidity('billingFlowInvitationEmail', false);
        }

        if (this.form.$valid) {
            this.PrincipalSvc.updatePrincipal(this.principal).then(
                data => {
                    this.form.$setPristine();
                    this.logger.success('success.update', data, null, { entityName: "Le Donneur d'ordre" });
                },
                error => {
                    var errorMessage = 'error.update';
                    if (error.status === 400 && error.data) {
                        errorMessage = ERROR_MESSAGE_MAP.hasOwnProperty(error.data.code)
                            ? ERROR_MESSAGE_MAP[error.data.code]
                            : 'error.functional.unknown';
                    }
                    this.logger.error(errorMessage, error);
                }
            );
        }
    }

    buyerInvoicesChange() {
        if (this.form.buyerInvoices.$error.billingFlowInvoices) {
            this.form.buyerInvoices.$setValidity('billingFlowInvoices', true);
        }
        this.documentarySpaceChange();
        if (!this.principal.buyer.hasInvoicesBuyer) {
            this.principal.buyer.paymentEnabled = false;
        }
    }

    buyerOrdersChange() {
        this.documentarySpaceChange();
    }

    documentarySpaceChange() {
        if (!this.principal.buyer.hasInvoicesBuyer && !this.principal.buyer.hasOrdersBuyer) {
            this.principal.buyer.hasDocumentarySpace = false;
        }
    }

    invitationTypeChange() {
        if (this.form.buyerBillingFlow.$error.billingFlowInvitationEmail) {
            this.form.buyerBillingFlow.$setValidity('billingFlowInvitationEmail', true);
        }
    }

    isBillingFlowInvoicesNotValid() {
        return (
            !this.principal.buyer.hasInvoicesBuyer &&
            this.principal.buyer.hasOrdersBuyer &&
            this.principal.buyer.hasBuyerBillingFlow
        );
    }

    isBillingFlowInvitationEmailNotValid() {
        return (
            this.principal.buyer.invitationType === this.invitationTypes[1] && this.principal.buyer.hasBuyerBillingFlow
        );
    }
    isTransmissionModeRequired() {
        return (
            !this.principal.buyer.transmissionModeMail &&
            !this.principal.buyer.transmissionModeFtp &&
            this.principal.buyer.paramBuyer
        );
    }

    resetReportRemindersFrequencyIfNeeded() {
        if (!this.buyerReportRemindersFrequencyAllowed) {
            this.principal.buyer.buyerReportRemindersFrequency = this.PRINCIPAL.reportFrequencies[3];
        }
    }
}
angular.module('app.principal').component('principalBuyer', {
    templateUrl: require('./principal-buyer.html'),
    controller: principalBuyerCtrl,
    bindings: { countries: '<', ladProviders: '<', principal: '<', create: '<' },
});
